import { TmpBoundaryApiFactory, TmpBoundaryPost, TmpBoundaryGet } from '@/api'
import { BaseInitRequest, BaseUserActionRequest } from '@/requests/baseRequest'
import { AxiosPromise } from 'axios'
/**
 * 境界立会仮申請登録
 */
export class CreateRequest extends BaseUserActionRequest {
  private tmpBoundary: TmpBoundaryPost
  constructor(tmpBoundary: TmpBoundaryPost) {
    super()
    this.tmpBoundary = tmpBoundary
  }

  protected request(): AxiosPromise<TmpBoundaryPost> {
    const api = TmpBoundaryApiFactory()
    return api.tmpBoundaryCreate(this.tmpBoundary)
  }
}

/**
 * 境界立会仮申請情報取得(仮申請者)
 */
export class ApplicantReadRequest extends BaseInitRequest {
  private tmpBoundaryId: number
  constructor(tmpBoundaryId: number) {
    super()
    this.tmpBoundaryId = tmpBoundaryId
  }

  protected request(): AxiosPromise<TmpBoundaryGet> {
    const api = TmpBoundaryApiFactory()
    return api.tmpBoundaryRead(this.tmpBoundaryId)
  }

  /**
   * 400エラー時の処理
   */
  protected badRequest(): void {
    // 認証エラーページに飛ばす
    this.transitionLoginPage()
  }

  /**
   * 403エラー時の処理
   */
  protected forbidden(): void {
    // 認証エラーページに飛ばす
    this.transitionLoginPage()
  }

  /**
   * 404エラー時の処理
   */
  protected notFound(): void {
    // 認証エラーページに飛ばす
    this.transitionLoginPage()
  }
}
